import { ArrowUpRight, MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import DesignCTA from "@/components/DesignCTA";
import { HOCKEY_GROUPS, IMAGES, SPORTS, waLink } from "@/data/content";

const HOCKEY_WA = waLink(SPORTS.find((s) => s.id === "hockey").msg);

export default function Hockey() {
  return (
    <>
      <PageHero
        testId="hockey-hero"
        eyebrow="Product Range"
        title="Ice Hockey Teamwear"
        sub="Our core specialization. Jerseys, pants, socks, teamwear and training apparel — produced to your club's design, colors and sizing."
        img={IMAGES.hockeyPuck}
      />

      <section className="py-14 md:py-20" data-testid="hockey-groups">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-14">
          {HOCKEY_GROUPS.map((g, i) => (
            <Reveal key={g.id}>
              <div
                id={g.id}
                data-testid={`hockey-group-${g.id}`}
                className={`scroll-mt-28 grid lg:grid-cols-2 gap-8 lg:gap-12 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}
              >
                <div className="relative h-60 sm:h-80 lg:h-[360px] rounded-lg overflow-hidden border border-slate-200 lg:[direction:ltr]">
                  <img src={g.img} alt={g.name} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
                </div>
                <div className="lg:[direction:ltr]">
                  <span className="eyebrow">
                    {String(i + 1).padStart(2, "0")} — Hockey
                  </span>
                  <h2 className="mt-3 font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl text-navy leading-[1.05]">
                    {g.name}
                  </h2>
                  <p className="mt-4 text-base text-slate-600 leading-relaxed max-w-lg">{g.desc}</p>
                  <a
                    href={HOCKEY_WA}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`hockey-quote-${g.id}`}
                    className="mt-6 link-accent"
                  >
                    <MessageCircle size={15} />
                    Discuss on WhatsApp
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-14 md:pb-20" data-testid="hockey-note">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="bg-icelight border border-ice/30 rounded-lg p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-5">
              <p className="text-sm text-navy leading-relaxed flex-1">
                Looking for something not listed here — accessories, special-event jerseys or
                a complete club program? Tell us what your team needs.
              </p>
              <a
                href={HOCKEY_WA}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hockey-note-cta"
                className="btn-navy shrink-0"
              >
                <MessageCircle size={16} />
                Ask us <ArrowUpRight size={16} />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <DesignCTA />
    </>
  );
}
